(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-scenes"] && !Shopify.designMode) return;
  try {
    
  class ActivityScenes extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-scene-tab]'));
      this.backgrounds = Array.from(this.querySelectorAll('[data-scene-bg]'));
      this.overlays = Array.from(this.querySelectorAll('[data-scene-overlay]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(Number(tab.dataset.sceneTab)));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });

      this.onBlockSelect = (event) => {
        const tab = event.target.closest('[data-scene-tab]');
        if (!tab || !this.tabs.includes(tab)) return;
        this.select(Number(tab.dataset.sceneTab));
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    onKeydown(event) {
      const keys = ['ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (!keys.includes(event.key)) return;

      event.preventDefault();
      const current = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
      let next = current;

      if (event.key === 'ArrowDown') next = Math.min(this.tabs.length - 1, current + 1);
      if (event.key === 'ArrowUp') next = Math.max(0, current - 1);
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;

      this.select(next);
      this.tabs[next]?.focus();
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.backgrounds.forEach((bg, i) => {
        const active = i === index;
        bg.classList.toggle('is-active', active);

        if (active) {
          bg.querySelectorAll('picture img[loading="lazy"]').forEach((img) => {
            if (img.complete) return;
            img.loading = 'eager';
            const src = img.currentSrc || img.src;
            if (src) img.src = src;
          });
        }
      });

      this.overlays.forEach((overlay, i) => {
        overlay.classList.toggle('is-active', i === index);
      });
    }
  }

  if (!customElements.get('activity-scenes')) {
    customElements.define('activity-scenes', ActivityScenes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["back-to-top"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('global-back-to-top')) {
    customElements.define('global-back-to-top', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;

        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const updateVisibility = () => {
          button.hidden = window.scrollY <= 400;
        };

        button.addEventListener('click', () => {
          // Move keyboard focus before the button becomes hidden at the top.
          const main = document.getElementById('MainContent');
          if (main && document.activeElement === button) {
            const hadTabindex = main.hasAttribute('tabindex');
            if (!hadTabindex) main.setAttribute('tabindex', '-1');
            main.focus({ preventScroll: true });
            if (!hadTabindex) {
              main.addEventListener('blur', () => main.removeAttribute('tabindex'), { once: true });
            }
          }

          window.scrollTo({
            top: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, { signal });

        window.addEventListener('scroll', updateVisibility, { passive: true, signal });
        window.addEventListener('pageshow', updateVisibility, { signal });
        updateVisibility();
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-voices"] && !Shopify.designMode) return;
  try {
    
  class VoicesCarousel extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.customer-voices');
      this.track = this.querySelector('[data-voices-track]');
      this.grid = this.querySelector('[data-voices-grid]');
      this.progressThumb = this.querySelector('[data-voices-progress]');

      if (!this.section || !this.track || !this.grid) return;

      this.onResize = this._debounce(this.refresh.bind(this), 100);
      this.onScroll = this.updateControls.bind(this);

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.track);
      this.mediaQuery = window.matchMedia('screen and (min-width: 768px)');
      this.mediaQuery.addEventListener('change', this.onResize);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.bindDragScroll();

      requestAnimationFrame(() => this.refresh());
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mediaQuery?.removeEventListener('change', this.onResize);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.unbindDragScroll();
    }

    bindDragScroll() {
      this.dragState = null;
      this.suppressClick = false;

      this.onPointerDown = (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (event.target.closest('button, a, input, textarea, select, label, [role="button"]')) return;
        if (this.getMaxScroll() <= 0) return;

        this.dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startScrollLeft: this.track.scrollLeft,
          moved: false,
        };

        this.track.classList.add('is-dragging');
        this.track.setPointerCapture(event.pointerId);
      };

      this.onPointerMove = (event) => {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;

        const deltaX = event.clientX - this.dragState.startX;
        if (Math.abs(deltaX) > 2) {
          this.dragState.moved = true;
          event.preventDefault();
        }

        this.track.scrollLeft = this.dragState.startScrollLeft - deltaX;
      };

      this.endDrag = (event) => {
        if (!this.dragState || event.pointerId !== this.dragState.pointerId) return;

        if (this.dragState.moved) {
          this.suppressClick = true;
          window.setTimeout(() => {
            this.suppressClick = false;
          }, 0);
        }

        this.track.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(event.pointerId)) {
          this.track.releasePointerCapture(event.pointerId);
        }
        this.dragState = null;
      };

      this.onClickCapture = (event) => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      };

      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointermove', this.onPointerMove);
      this.track.addEventListener('pointerup', this.endDrag);
      this.track.addEventListener('pointercancel', this.endDrag);
      this.track.addEventListener('click', this.onClickCapture, true);
    }

    unbindDragScroll() {
      if (!this.track) return;

      this.track.removeEventListener('pointerdown', this.onPointerDown);
      this.track.removeEventListener('pointermove', this.onPointerMove);
      this.track.removeEventListener('pointerup', this.endDrag);
      this.track.removeEventListener('pointercancel', this.endDrag);
      this.track.removeEventListener('click', this.onClickCapture, true);
      this.track.classList.remove('is-dragging');
      this.dragState = null;
    }

    _debounce(fn, wait) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), wait);
      };
    }

    isDesktop() {
      return this.mediaQuery?.matches;
    }

    getSlides() {
      const selector = this.isDesktop() ? '.customer-voices__card' : '.customer-voices__pair';
      return Array.from(this.grid.querySelectorAll(selector)).filter((slide) => slide.clientWidth > 0);
    }

    getGap() {
      return parseFloat(getComputedStyle(this.section).getPropertyValue('--voices-gap')) || 12;
    }

    getPagePadding() {
      const styles = getComputedStyle(this.section);
      return parseFloat(styles.getPropertyValue('--page-padding')) || 16;
    }

    getTargetVisible() {
      return this.isDesktop() ? 4 : 1;
    }

    getSlideWidth() {
      const trackWidth = this.track.clientWidth;
      if (!trackWidth) return this.isDesktop() ? 280 : 280;

      const gap = this.getGap();
      const visible = this.getTargetVisible();
      const pagePadding = this.getPagePadding();
      const paddingAdjust = this.isDesktop() ? pagePadding * 2 : pagePadding;
      return Math.max(180, (trackWidth - paddingAdjust - gap * (visible - 1)) / visible);
    }

    getEndSpace() {
      return this.getPagePadding();
    }

    getMaxScroll() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    refresh() {
      const slideWidth = this.getSlideWidth();
      this.section.style.setProperty('--voices-slide-width', `${slideWidth}px`);
      this.section.style.setProperty('--voices-end-space', `${this.getEndSpace()}px`);

      const maxScroll = this.getMaxScroll();
      if (this.track.scrollLeft > maxScroll) {
        this.track.scrollLeft = maxScroll;
      }

      this.updateControls();
    }

    updateControls() {
      if (!this.progressThumb) return;

      const maxScroll = this.getMaxScroll();
      const trackWidth = this.track.clientWidth;
      const scrollWidth = this.track.scrollWidth;
      const thumbRatio = scrollWidth > 0 ? trackWidth / scrollWidth : 1;
      const thumbWidth = Math.min(1, Math.max(0.22, thumbRatio));
      const maxOffset = 1 - thumbWidth;
      const progress = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;

      this.progressThumb.style.width = `${thumbWidth * 100}%`;
      this.progressThumb.style.left = `${progress * maxOffset * 100}%`;
    }
  }

  if (!customElements.get('voices-carousel')) {
    customElements.define('voices-carousel', VoicesCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSectionReveal extends HTMLElement {
    connectedCallback() {
      this.whenReady(() => {
        if (typeof theme !== 'undefined' && theme.config?.motionReduced) {
          this.resetStage();
          return;
        }

        this.init();
      });

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        this.onSectionUnload = this.refresh.bind(this);
        document.addEventListener('shopify:section:unload', this.onSectionUnload);
      }
    }

    disconnectedCallback() {
      if (this.onSectionUnload) {
        document.removeEventListener('shopify:section:unload', this.onSectionUnload);
      }

      this.stopAnimation();
    }

    whenReady(callback) {
      const isReady = () => typeof Motion !== 'undefined' && typeof theme !== 'undefined';

      if (isReady()) {
        callback();
        return;
      }

      let attempts = 0;
      const retry = () => {
        if (isReady()) {
          callback();
          return;
        }

        attempts += 1;
        if (attempts < 120) {
          requestAnimationFrame(retry);
        }
      };

      retry();
    }

    get stage() {
      return this.querySelector('.faq-section__stage');
    }

    get scrollTarget() {
      return this.closest('.shopify-section') || this.closest('.faq-section--has-image');
    }

    init() {
      const stage = this.stage;
      const scrollTarget = this.scrollTarget;
      if (!stage || !scrollTarget || this.revealBound) return;

      this.revealBound = true;

      this.onScroll = () => {
        if (this.revealed) return;

        const triggerLine = window.innerHeight * 0.5;
        if (scrollTarget.getBoundingClientRect().top <= triggerLine) {
          this.reveal();
        }
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }

    reveal() {
      const stage = this.stage;
      if (!stage || this.revealed) return;

      this.revealed = true;
      this.unbindScroll();

      this.playAnimation = Motion.animate(
        stage,
        { transform: 'translateY(0)' },
        { duration: 0.9, easing: [0.16, 1, 0.3, 1] }
      );
    }

    unbindScroll() {
      if (!this.onScroll) return;

      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.onScroll = null;
    }

    stopAnimation() {
      this.playAnimation?.stop?.();
      this.playAnimation = null;
      this.unbindScroll();
    }

    resetStage() {
      if (this.stage && typeof Motion !== 'undefined') {
        Motion.animate(this.stage, { transform: 'translateY(0)' }, { duration: 0 });
      }
    }

    refresh() {
      this.revealed = false;
      this.revealBound = false;
      this.stopAnimation();

      if (this.stage && typeof Motion !== 'undefined') {
        Motion.animate(this.stage, { transform: 'translateY(100%)' }, { duration: 0 });
        this.init();
      }
    }
  }

  if (!customElements.get('faq-section-reveal')) {
    customElements.define('faq-section-reveal', FaqSectionReveal);
  }

  const bootFaqSectionReveal = () => {
    document.querySelectorAll('faq-section-reveal').forEach((element) => {
      if (element.revealBound || typeof element.whenReady !== 'function') return;

      element.whenReady(() => {
        if (typeof theme !== 'undefined' && theme.config?.motionReduced) {
          element.resetStage();
          return;
        }

        element.init();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFaqSectionReveal, { once: true });
  } else {
    bootFaqSectionReveal();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('faq-section-reveal').forEach((element) => {
      element.whenReady?.(() => {
        if (typeof theme !== 'undefined' && theme.config?.motionReduced) {
          element.resetStage();
          return;
        }

        element.init();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-cards"] && !Shopify.designMode) return;
  try {
    
  class FeatureCarousel extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.feature-cards');
      this.track = this.querySelector('[data-feature-cards-track]');
      this.grid = this.querySelector('[data-feature-cards-grid]');
      this.prevBtn = this.querySelector('[data-feature-cards-prev]');
      this.nextBtn = this.querySelector('[data-feature-cards-next]');
      this.progressThumb = this.querySelector('[data-feature-cards-progress]');

      if (!this.section || !this.track || !this.grid) return;

      this.onResize = this._debounce(this.refresh.bind(this), 100);
      this.onScroll = this.updateControls.bind(this);

      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.track);
      this.mediaQuery = window.matchMedia('screen and (min-width: 768px)');
      this.mediaQuery.addEventListener('change', this.onResize);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.prevBtn?.addEventListener('click', () => this.scrollByCards(-1));
      this.nextBtn?.addEventListener('click', () => this.scrollByCards(1));
      this.onCardOver = this.onCardHover.bind(this);
      this.onTrackLeave = this.onCardLeave.bind(this);
      this.onWidthTransitionEnd = this.onCardTransitionEnd.bind(this);
      this.grid.addEventListener('mouseover', this.onCardOver);
      this.grid.addEventListener('mouseleave', this.onTrackLeave);
      this.grid.addEventListener('transitionend', this.onWidthTransitionEnd);

      this.initVideos();
      requestAnimationFrame(() => this.refresh());
    }

    initVideos() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');

        if (reduceMotion) {
          video.removeAttribute('autoplay');
          video.pause();
          return;
        }

        video.play()?.catch(() => {});
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mediaQuery?.removeEventListener('change', this.onResize);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.grid?.removeEventListener('mouseover', this.onCardOver);
      this.grid?.removeEventListener('mouseleave', this.onTrackLeave);
      this.grid?.removeEventListener('transitionend', this.onWidthTransitionEnd);
    }

    _debounce(fn, wait) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), wait);
      };
    }

    isDesktop() {
      return this.mediaQuery?.matches;
    }

    isFullWidth() {
      return this.section.classList.contains('feature-cards--full');
    }

    getSlides() {
      return Array.from(this.grid.querySelectorAll(':scope > .feature-cards__card')).filter(
        (slide) => slide.clientWidth > 0
      );
    }

    getGap() {
      return parseFloat(getComputedStyle(this.section).getPropertyValue('--feature-cards-gap')) || 12;
    }

    getPagePadding() {
      const styles = getComputedStyle(this.section);
      return parseFloat(styles.getPropertyValue('--page-padding')) || 16;
    }

    getTargetVisible() {
      if (this.isDesktop()) return this.isFullWidth() ? 4.45 : 4.2;
      return this.isFullWidth() ? 1.08 : 1.18;
    }

    getSlideWidth() {
      const trackWidth = this.track.clientWidth;
      if (!trackWidth) return this.isDesktop() ? 280 : 280;

      const gap = this.getGap();
      const visible = this.getTargetVisible();
      return Math.max(180, (trackWidth - gap * (visible - 1)) / visible);
    }

    getEndSpace() {
      if (this.isFullWidth()) {
        return this.isDesktop() ? this.getGap() : 16;
      }

      if (!this.isDesktop()) return this.getPagePadding();

      const trackRect = this.track.getBoundingClientRect();
      const scrollportOverflow = Math.max(0, trackRect.left + this.track.clientWidth - window.innerWidth);
      return this.getPagePadding() + this.getGap() + scrollportOverflow;
    }

    getMaxScroll() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    getItemStride() {
      if (this.isDesktop()) {
        return this.getSlideWidth() + this.getGap();
      }

      const slides = this.getSlides();
      const fallback = this.getSlideWidth() + this.getGap();
      if (slides.length < 2) return fallback;

      const measured = Math.abs(slides[1].offsetLeft - slides[0].offsetLeft);
      return measured > 0 ? measured : fallback;
    }

    onCardHover(event) {
      if (!this.isDesktop()) return;

      const card = event.target.closest('.feature-cards__card');
      if (!card || !this.grid.contains(card) || card === this.hoveredCard) return;

      this.hoveredCard = card;
      this.keepCardInView(card);
    }

    onCardLeave() {
      this.hoveredCard = null;
      if (!this.isDesktop()) return;
      window.setTimeout(() => this.updateControls(), 80);
    }

    onCardTransitionEnd(event) {
      if (event.propertyName !== 'width' && event.propertyName !== 'min-width') return;
      this.updateControls();
    }

    keepCardInView(card) {
      const expanded =
        parseFloat(getComputedStyle(this.section).getPropertyValue('--feature-cards-expanded-width')) ||
        card.offsetWidth;
      const cardLeft = card.offsetLeft;
      const cardRight = cardLeft + expanded;
      const viewLeft = this.track.scrollLeft;
      const viewRight = viewLeft + this.track.clientWidth;

      if (cardRight > viewRight - 4) {
        this.track.scrollTo({
          left: Math.max(0, cardRight - this.track.clientWidth),
          behavior: typeof theme !== 'undefined' && theme.config?.motionReduced ? 'auto' : 'smooth',
        });
      } else if (cardLeft < viewLeft) {
        this.track.scrollTo({
          left: Math.max(0, cardLeft),
          behavior: typeof theme !== 'undefined' && theme.config?.motionReduced ? 'auto' : 'smooth',
        });
      }
    }

    refresh() {
      const slideWidth = this.getSlideWidth();
      this.section.style.setProperty('--feature-cards-slide-width', `${slideWidth}px`);
      this.section.style.setProperty('--feature-cards-end-space', `${this.getEndSpace()}px`);

      const maxScroll = this.getMaxScroll();
      if (this.track.scrollLeft > maxScroll) {
        this.track.scrollLeft = maxScroll;
      }

      this.updateControls();
    }

    updateControls() {
      const maxScroll = this.getMaxScroll();
      const atStart = this.track.scrollLeft <= 1;
      const atEnd = this.track.scrollLeft >= maxScroll - 1;

      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;

      if (!this.progressThumb) return;

      const trackWidth = this.track.clientWidth;
      const scrollWidth = this.track.scrollWidth;
      const thumbRatio = scrollWidth > 0 ? trackWidth / scrollWidth : 1;
      const thumbWidth = Math.min(1, Math.max(0.18, thumbRatio));
      const maxOffset = 1 - thumbWidth;
      const progress = maxScroll > 0 ? this.track.scrollLeft / maxScroll : 0;

      this.progressThumb.style.width = `${thumbWidth * 100}%`;
      this.progressThumb.style.left = `${progress * maxOffset * 100}%`;
    }

    scrollByCards(count) {
      const itemStride = this.getItemStride();
      const maxScroll = this.getMaxScroll();
      let target = this.track.scrollLeft + count * itemStride;

      if (count > 0) {
        const remaining = maxScroll - this.track.scrollLeft;
        if (remaining > 0 && remaining <= itemStride) target = maxScroll;
      }

      this.track.scrollTo({
        left: Math.max(0, Math.min(maxScroll, target)),
        behavior: typeof theme !== 'undefined' && theme.config?.motionReduced ? 'auto' : 'smooth',
      });

      window.setTimeout(() => this.updateControls(), 120);
    }
  }

  if (!customElements.get('feature-carousel')) {
    customElements.define('feature-carousel', FeatureCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  class HealthFeatureShowcase extends HTMLElement {
    connectedCallback() {
      this.desktop = this.querySelector('[data-health-desktop]');
      this.galleryBlock = this.querySelector('[data-health-gallery-block]');
      this.pictureWrapper = this.querySelector('[data-health-picture-wrapper]');
      this.blurAfter = this.querySelector('[data-health-blur-after]');
      this.bgImage = this.querySelector('.health-feature-showcase__picture img');
      this.track = this.querySelector('[data-health-track]');
      this.cards = Array.from(this.querySelectorAll('[data-health-card]'));
      this.progress = this.querySelector('[data-health-progress]');
      this.prevButton = this.querySelector('[data-health-prev]');
      this.nextButton = this.querySelector('[data-health-next]');
      this.mobileTrack = this.querySelector('[data-health-mobile-track]');
      this.mobileProgress = this.querySelector('[data-health-mobile-progress]');
      this.stickyNavSection = document.querySelector('.product-sticky-nav-section');

      this.navOffset = 0;
      this.preStickyScroll = 0;
      this.stickyTravel = 374;
      this.activeIndex = 0;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onTrackScroll = this.onTrackScroll.bind(this);
      this.onMobileScroll = this.onMobileScroll.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);

      this.updateNavOffset();
      this.measureLayout();
      this.initCardVideos();

      requestAnimationFrame(() => {
        this.measureLayout();
        this.updateScroll();
        this.updateCarouselState();
        this.updateMobileProgress();
        this.initCardVideos();
      });

      this.bgImage?.addEventListener('load', this.onResize, { once: true });

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      this.track?.addEventListener('scroll', this.onTrackScroll, { passive: true });
      this.mobileTrack?.addEventListener('scroll', this.onMobileScroll, { passive: true });
      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);

      this.resizeObserver = new ResizeObserver(this.onResize);
      const navBar = document.querySelector('.product-sticky-nav__bar');
      if (navBar) this.resizeObserver.observe(navBar);
      if (this.stickyNavSection) this.resizeObserver.observe(this.stickyNavSection);
      if (this.galleryBlock) this.resizeObserver.observe(this.galleryBlock);
      this.resizeObserver.observe(this);

      this.onBlockSelect = (event) => {
        const card = event.target.closest('[data-health-card], [data-health-mobile-card]');
        const index = Number(card?.dataset.healthCard ?? card?.dataset.healthMobileCard);
        if (Number.isNaN(index)) return;
        this.goToIndex(index);
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.track?.removeEventListener('scroll', this.onTrackScroll);
      this.mobileTrack?.removeEventListener('scroll', this.onMobileScroll);
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.resizeObserver?.disconnect();
    }

    updateNavOffset() {
      const navBar = document.querySelector('.product-sticky-nav__bar');
      const navHeight = navBar ? navBar.offsetHeight : 0;
      this.navOffset = this.stickyNavSection ? this.stickyNavSection.offsetHeight : navHeight;
      this.style.setProperty('--health-nav-offset', `${this.navOffset}px`);
    }

    measureLayout() {
      this.updateNavOffset();

      if (!this.desktop || getComputedStyle(this.desktop).display === 'none') return;

      const viewportWidth = this.desktop.offsetWidth || window.innerWidth;
      let bgHeight = viewportWidth * (1255 / 1440);

      if (this.bgImage?.naturalWidth && this.bgImage?.naturalHeight) {
        bgHeight = viewportWidth * (this.bgImage.naturalHeight / this.bgImage.naturalWidth);
      } else if (this.bgImage?.height && this.bgImage?.width) {
        bgHeight = viewportWidth * (this.bgImage.height / this.bgImage.width);
      }

      const viewportHeight = Math.max(400, window.innerHeight);
      const introRowHeight = bgHeight * (920 / 1255);
      const galleryOverlap = bgHeight * (374 / 1255);
      const galleryPaddingBottom = bgHeight * (96 / 1255);
      const pictureHeight = bgHeight;

      void this.galleryBlock?.offsetHeight;

      const galleryHeight = this.galleryBlock?.offsetHeight || 0;

      this.preStickyScroll = Math.max(0, pictureHeight - viewportHeight);
      this.stickyTravel = Math.max(galleryHeight - galleryOverlap, 1);

      this.style.setProperty('--health-bg-height', `${bgHeight}px`);
      this.style.setProperty('--health-design-bg-height', `${bgHeight}px`);
      this.style.setProperty('--health-picture-height', `${pictureHeight}px`);
      this.style.setProperty('--health-viewport-height', `${viewportHeight}px`);
      this.style.setProperty('--health-intro-row-height', `${introRowHeight}px`);
      this.style.setProperty('--health-gallery-overlap', `${galleryOverlap}px`);
      this.style.setProperty('--health-gallery-padding-bottom', `${galleryPaddingBottom}px`);
      this.style.setProperty('--health-intro-offset', `${viewportWidth * (220 / 1920)}px`);
    }

    getRevealProgress() {
      const scrolled = this.getSectionScroll();

      if (scrolled <= this.preStickyScroll) return 0;

      return Math.min(1, (scrolled - this.preStickyScroll) / Math.max(this.stickyTravel, 1));
    }

    easeOutCubic(value) {
      return 1 - Math.pow(1 - value, 3);
    }

    updateScroll() {
      if (!this.galleryBlock || !this.blurAfter) return;

      this.galleryBlock.style.removeProperty('opacity');
      this.galleryBlock.style.removeProperty('transform');
      this.galleryBlock.style.removeProperty('pointer-events');

      const progress = this.getRevealProgress();
      const eased = this.prefersReducedMotion.matches ? (progress >= 1 ? 1 : 0) : this.easeOutCubic(progress);

      if (progress > 0) {
        this.galleryBlock.classList.remove('scrollback-hide');
      } else {
        this.galleryBlock.classList.add('scrollback-hide');
      }

      const blurPx = eased * 20;
      const brightness = 1 - eased * 0.4;
      const filterValue =
        blurPx > 0 ? `blur(${blurPx}px) brightness(${brightness.toFixed(2)})` : 'blur(0px) brightness(1)';

      this.blurAfter.style.backdropFilter = filterValue;
      this.blurAfter.style.webkitBackdropFilter = filterValue;
    }

    getSectionScroll() {
      if (!this.desktop) return 0;

      const rect = this.desktop.getBoundingClientRect();
      return Math.max(0, this.navOffset - rect.top);
    }

    onScroll() {
      this.updateScroll();
    }

    onResize() {
      this.measureLayout();
      this.updateScroll();
      this.updateCarouselState();
      this.updateMobileProgress();
      this.initCardVideos();
    }

    initCardVideos() {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelectorAll('.health-feature-showcase__card-media video, .health-feature-showcase__mobile-card-media video').forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');

        if (prefersReducedMotion) {
          video.removeAttribute('autoplay');
          video.pause();
          return;
        }

        video.play()?.catch(() => {});
      });
    }

    getVisibleCardCount() {
      return 4;
    }

    getCardStride() {
      if (!this.track || this.cards.length === 0) return 0;

      const card = this.cards[0];
      const container = this.track.querySelector('.health-feature-showcase__item-container');
      const styles = window.getComputedStyle(container || this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.offsetWidth + gap;
    }

    getActiveIndex() {
      if (!this.track || this.cards.length === 0) return 0;

      const stride = this.getCardStride();
      if (stride <= 0) return 0;

      return Math.min(this.cards.length - 1, Math.max(0, Math.round(this.track.scrollLeft / stride)));
    }

    updateCarouselState() {
      if (!this.track || this.cards.length === 0) return;

      this.activeIndex = this.getActiveIndex();
      const visibleCount = this.getVisibleCardCount();
      const progressDenominator = Math.max(1, this.cards.length - visibleCount + 1);
      const progressPercent = ((this.activeIndex + 1) / progressDenominator) * 100;

      this.style.setProperty('--health-progress', `${Math.min(100, progressPercent)}%`);

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 1;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;
      }
    }

    onTrackScroll() {
      this.updateCarouselState();
    }

    goToIndex(index) {
      const stride = this.getCardStride();
      if (!this.track || stride <= 0) return;

      const targetIndex = Math.min(this.cards.length - 1, Math.max(0, index));
      this.track.scrollTo({ left: stride * targetIndex, behavior: 'smooth' });
      this.mobileTrack?.scrollTo({ left: this.getMobileStride() * targetIndex, behavior: 'smooth' });
    }

    onPrev() {
      this.goToIndex(this.getActiveIndex() - 1);
    }

    onNext() {
      this.goToIndex(this.getActiveIndex() + 1);
    }

    getMobileStride() {
      if (!this.mobileTrack) return 0;

      const card = this.mobileTrack.querySelector('[data-health-mobile-card]');
      if (!card) return 0;

      const styles = window.getComputedStyle(this.mobileTrack);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.offsetWidth + gap;
    }

    updateMobileProgress() {
      if (!this.mobileTrack || !this.mobileProgress) return;

      const cardCount = this.mobileTrack.children.length;
      const maxScroll = this.mobileTrack.scrollWidth - this.mobileTrack.clientWidth;

      if (maxScroll <= 0 || cardCount <= 0) {
        this.style.setProperty('--health-mobile-progress', '100%');
        return;
      }

      const fillMin = (this.mobileTrack.clientWidth / this.mobileTrack.scrollWidth) * 100;
      const ratio = this.mobileTrack.scrollLeft / maxScroll;
      const fillWidth = fillMin + ratio * (100 - fillMin);

      this.style.setProperty('--health-mobile-progress', `${fillWidth}%`);
    }

    onMobileScroll() {
      this.updateMobileProgress();
    }
  }

  if (!customElements.get('health-feature-showcase')) {
    customElements.define('health-feature-showcase', HealthFeatureShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  class HowItWorks extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('[data-how-step]'));
      this.slides = Array.from(this.querySelectorAll('[data-how-slide]'));
      this.railThumb = this.querySelector('[data-how-rail]');
      this.stepsTrack = this.querySelector('[data-how-steps-track]');
      this.index = 0;
      this.progress = 0;
      this.autoplayInterval = Number(this.dataset.autoplayInterval) || 5000;
      this.events = new AbortController();
      const options = { signal: this.events.signal };

      this.steps.forEach((step) => {
        step.addEventListener('click', () => this.select(Number(step.dataset.index)), options);
      });
      this.querySelector('[data-how-prev]')?.addEventListener('click', () => this.select(this.index - 1), options);
      this.querySelector('[data-how-next]')?.addEventListener('click', () => this.select(this.index + 1), options);

      document.addEventListener('visibilitychange', () => this.scheduleAutoplay(), options);
      this.addEventListener('shopify:block:select', (event) => {
        const step = event.target.closest('[data-how-step]');
        if (!step) return;
        this.select(Number(step.dataset.index));
      }, options);

      this.resizeObserver = new ResizeObserver(() => this.updateRail());
      if (this.stepsTrack) this.resizeObserver.observe(this.stepsTrack);
      this.steps.forEach((step) => this.resizeObserver.observe(step));
      this.initVideos();
      this.select(0, true);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.autoplayFrame);
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }

    scheduleAutoplay() {
      cancelAnimationFrame(this.autoplayFrame);
      this.progress = this.steps.length < 2 ? 1 : 0;
      this.updateRail();
      if (!this.isConnected || this.steps.length < 2 || document.hidden) return;

      // Use the same clock for the rail fill and the next slide.
      const startedAt = performance.now();
      const tick = (now) => {
        this.progress = Math.min(1, (now - startedAt) / this.autoplayInterval);
        if (this.railThumb) {
          this.railThumb.style.height = `${this.railHeight * this.progress}px`;
        }

        if (this.progress >= 1) {
          this.select(this.index + 1);
          return;
        }
        this.autoplayFrame = requestAnimationFrame(tick);
      };
      this.autoplayFrame = requestAnimationFrame(tick);
    }

    initVideos() {
      this.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        video.loop = true;
      });
    }

    select(nextIndex, immediate = false) {
      const count = this.steps.length;
      if (!count) return;

      const index = ((nextIndex % count) + count) % count;
      this.index = index;

      this.steps.forEach((step, i) => {
        const active = i === index;
        step.classList.toggle('is-active', active);
        step.setAttribute('aria-current', active ? 'true' : 'false');
      });

      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        this.syncVideo(slide, active, immediate);
      });

      this.scheduleAutoplay();
    }

    syncVideo(slide, active, immediate) {
      slide.querySelectorAll('video').forEach((video) => {
        if (active) {
          if (immediate) video.currentTime = 0;
          video.play()?.catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    updateRail() {
      if (!this.railThumb) return;

      const active = this.steps[this.index];
      if (!active) return;

      this.railHeight = active.offsetHeight;
      this.railThumb.style.transform = `translateY(${active.offsetTop}px)`;
      this.railThumb.style.height = `${this.railHeight * this.progress}px`;
    }
  }

  if (!customElements.get('how-it-works')) {
    customElements.define('how-it-works', HowItWorks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-support"] && !Shopify.designMode) return;
  try {
    
  class LifestyleSupport extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-lifestyle-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-lifestyle-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(Number(tab.dataset.index)));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });

      this.onBlockSelect = (event) => {
        const tab = event.target.closest('[data-lifestyle-tab]');
        if (!tab || !this.tabs.includes(tab)) return;
        this.select(Number(tab.dataset.index));
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);

      this.initVideos();
    }

    initVideos() {
      this.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        video.loop = true;
      });
    }

    onKeydown(event) {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;

      event.preventDefault();
      const current = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
      let next = current;

      if (event.key === 'ArrowRight') next = Math.min(this.tabs.length - 1, current + 1);
      if (event.key === 'ArrowLeft') next = Math.max(0, current - 1);
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;

      this.select(next);
      this.tabs[next]?.focus();
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;

        if (active) {
          panel.querySelectorAll('picture img[loading="lazy"]').forEach((img) => {
            if (img.complete) return;

            img.loading = 'eager';
            const src = img.currentSrc || img.src;
            if (src) img.src = src;
          });
        }

        panel.querySelectorAll('video').forEach((video) => {
          if (active) video.play()?.catch(() => {});
          else video.pause();
        });
      });
    }
  }

  if (!customElements.get('lifestyle-support')) {
    customElements.define('lifestyle-support', LifestyleSupport);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["model-hotspots"] && !Shopify.designMode) return;
  try {
    
  class ModelHotspots extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.model-hotspots__track');
      this.spots = Array.from(this.querySelectorAll('[data-hotspot-index]'));
      this.viewer = this.querySelector('model-viewer');
      this.count = Number(this.dataset.count || 0) || 0;
      this.rotate = this.dataset.rotate === 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.revealed = -1;
      this.ticking = false;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onScroll;

      this.ensureModelViewer(() => {
        this.initViewer();
        this.bindScroll();
      });
    }

    ensureModelViewer(callback) {
      if (!this.viewer) {
        callback();
        return;
      }

      if (customElements.get('model-viewer')) {
        callback();
        return;
      }

      if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([
          { name: 'shopify-xr', version: '1.0' },
          { name: 'model-viewer-ui', version: '1.0', onLoad: callback }
        ]);
        return;
      }

      callback();
    }

    initViewer() {
      if (!this.viewer) return;

      const reveal = () => {
        if (typeof this.viewer.dismissPoster === 'function') {
          this.viewer.dismissPoster();
        }
        this.viewer.classList.add('is-ready');
      };

      if (this.viewer.loaded) {
        reveal();
        return;
      }

      this.viewer.addEventListener('load', reveal, { once: true });
    }

    bindScroll() {
      if (this.reducedMotion || window.Shopify?.designMode) {
        this.reveal(this.count, 1);
        return;
      }

      this.onScroll();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    progress() {
      if (!this.track) return 0;
      const rect = this.track.getBoundingClientRect();
      const scrollable = Math.max(this.track.offsetHeight - window.innerHeight, 1);
      return Math.min(Math.max(-rect.top / scrollable, 0), 1);
    }

    update() {
      const t = this.progress();
      const next = this.count > 0 ? Math.min(this.count, Math.ceil(t * this.count)) : 0;
      this.reveal(next, t);
    }

    reveal(count, t) {
      if (count !== this.revealed) {
        this.revealed = count;
        this.spots.forEach((item) => {
          const index = Number(item.dataset.hotspotIndex);
          const visible = index < count;
          item.classList.toggle('is-visible', visible);
          item.classList.toggle('is-current', visible && index === count - 1);
          item.toggleAttribute('aria-hidden', !visible);
        });
      }

      if (!this.rotate || !this.viewer || typeof t !== 'number') return;
      const yaw = -18 + t * 48;
      this.viewer.cameraOrbit = `${yaw.toFixed(2)}deg 74deg 108%`;
    }
  }

  if (!customElements.get('model-hotspots')) {
    customElements.define('model-hotspots', ModelHotspots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["performance-stats"] && !Shopify.designMode) return;
  try {
    
  class PerformanceStats extends HTMLElement {
    connectedCallback() {
      this.scrollRoot = this.querySelector('[data-performance-scroll]');
      this.viewport = this.querySelector('.performance-stats__viewport');
      this.track = this.querySelector('[data-performance-track]');
      this.items = Array.from(this.querySelectorAll('[data-performance-item]'));
      this.mobileTrack = this.querySelector('[data-performance-mobile-track]');
      this.mobileSlides = Array.from(this.querySelectorAll('[data-performance-mobile-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-performance-dot]'));
      this.stickyNavSection = document.querySelector('.product-sticky-nav-section');

      this.navOffset = 0;
      this.cachedLayout = null;
      this.lastOffset = null;
      this.rafId = null;
      this.ticking = false;
      this.mobileActiveIndex = 0;
      this.mobileAutoplayEnabled = this.dataset.mobileAutoplay !== 'false';
      this.mobileAutoplayDelay = (Number(this.dataset.mobileAutoplaySpeed) || 5) * 1000;
      this.mobileAutoplayTimer = null;
      this.mobileScrollEndTimer = null;
      this.mobileAutoplayPaused = false;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.style.setProperty('--performance-stats-autoplay-duration', `${this.mobileAutoplayDelay}ms`);

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onMobileScroll = this.onMobileScroll.bind(this);
      this.onMobileInteraction = this.onMobileInteraction.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      this.onDotClick = this.onDotClick.bind(this);

      this.updateViewportMetrics();

      requestAnimationFrame(() => {
        this.measureLayout();
        this.updateDesktopScroll(true);
        this.onMobileScroll();
        this.startMobileAutoplay();
      });

      this.track?.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', this.onResize, { once: true });
      });

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.mobileTrack?.addEventListener('scroll', this.onMobileScroll, { passive: true });
      this.mobileTrack?.addEventListener('pointerdown', this.onMobileInteraction);
      this.mobileTrack?.addEventListener('touchstart', this.onMobileInteraction, { passive: true });
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.resizeObserver = new ResizeObserver(this.onResize);
      const navBar = document.querySelector('.product-sticky-nav__bar');
      if (navBar) this.resizeObserver.observe(navBar);
      if (this.stickyNavSection) this.resizeObserver.observe(this.stickyNavSection);
      this.resizeObserver.observe(this);

      this.onBlockSelect = (event) => {
        const index = Number(
          event.target.closest('[data-performance-item]')?.dataset.performanceItem ??
            event.target.closest('[data-performance-mobile-slide]')?.dataset.performanceMobileSlide
        );
        if (!Number.isNaN(index)) this.goToSlide(index);
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.mobileTrack?.removeEventListener('scroll', this.onMobileScroll);
      this.mobileTrack?.removeEventListener('pointerdown', this.onMobileInteraction);
      this.mobileTrack?.removeEventListener('touchstart', this.onMobileInteraction);
      this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.resizeObserver?.disconnect();
      this.stopMobileAutoplay();
      clearTimeout(this.mobileScrollEndTimer);
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    isDesktop() {
      return window.matchMedia('(min-width: 768px)').matches;
    }

    updateViewportMetrics() {
      const navBar = document.querySelector('.product-sticky-nav__bar');
      const navHeight = navBar ? navBar.offsetHeight : 0;
      this.navOffset = this.stickyNavSection ? this.stickyNavSection.offsetHeight : navHeight;

      this.style.setProperty('--performance-stats-nav-height', `${navHeight}px`);
      this.style.setProperty('--performance-stats-nav-offset', `${this.navOffset}px`);
      this.style.setProperty('--performance-stats-viewport-height', `calc(100svh - ${navHeight}px)`);
    }

    measureLayout() {
      if (!this.scrollRoot || !this.viewport || !this.track || this.items.length === 0) {
        this.cachedLayout = null;
        return;
      }

      const trackHeight = this.track.getBoundingClientRect().height;
      const panelHeight = this.track.parentElement.clientHeight;
      const maxIndex = Math.max(0, this.items.length - 1);
      const maxTravel = Math.max(0, trackHeight - panelHeight);
      // Pin for the full track height, but only translate its overflow out of the panel.
      const scrollDistance = maxTravel > 0 ? trackHeight : 0;

      this.style.setProperty('--performance-stats-scroll-distance', `${scrollDistance}px`);

      this.cachedLayout = {
        scrollDistance,
        maxTravel,
        maxIndex,
      };
    }

    getScrolled() {
      if (!this.scrollRoot) return 0;

      const rect = this.scrollRoot.getBoundingClientRect();
      return Math.max(0, this.navOffset - rect.top);
    }

    getScrollStart() {
      if (!this.scrollRoot) return 0;

      const rect = this.scrollRoot.getBoundingClientRect();
      return window.scrollY + rect.top - this.navOffset;
    }

    updateDesktopScroll(force = false) {
      if (!this.isDesktop() || !this.cachedLayout || !this.track) return;

      const scrolled = this.getScrolled();
      const { scrollDistance, maxTravel, maxIndex } = this.cachedLayout;
      const progress = scrollDistance > 0 ? Math.min(scrolled / scrollDistance, 1) : 0;
      const offset = -progress * maxTravel;

      if (force || this.lastOffset !== offset) {
        this.lastOffset = offset;
        this.track.style.transform = offset === 0 ? 'translate3d(0, 0, 0)' : `translate3d(0, ${offset}px, 0)`;

        const index = progress * maxIndex;
        this.items.forEach((item, i) => {
          const distance = Math.abs(index - i);
          item.style.opacity = distance >= 1 ? '0.4' : String(1 - distance * 0.6);
        });
      }
    }

    onScroll() {
      if (!this.isDesktop() || this.ticking) return;

      this.ticking = true;
      this.rafId = requestAnimationFrame(() => {
        this.ticking = false;
        this.updateDesktopScroll();
      });
    }

    onResize() {
      this.updateViewportMetrics();
      this.measureLayout();
      this.lastOffset = null;
      this.updateDesktopScroll(true);
      this.onMobileScroll();

      if (this.isDesktop()) {
        this.stopMobileAutoplay();
      } else {
        this.startMobileAutoplay();
      }
    }

    onMobileScroll() {
      if (!this.mobileTrack || this.mobileSlides.length === 0) return;

      const trackRect = this.mobileTrack.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      let activeIndex = 0;
      let minDistance = Infinity;

      this.mobileSlides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - trackCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      if (activeIndex !== this.mobileActiveIndex) {
        this.mobileActiveIndex = activeIndex;
        this.updateMobilePagination(activeIndex);
        this.mobileAutoplayPaused = false;
        this.restartMobileAutoplay();
      }

      clearTimeout(this.mobileScrollEndTimer);
      this.mobileScrollEndTimer = window.setTimeout(() => {
        this.mobileAutoplayPaused = false;
        this.restartMobileAutoplay();
      }, 180);
    }

    updateMobilePagination(activeIndex) {
      this.dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.restartProgressAnimation(activeIndex);
    }

    restartProgressAnimation(activeIndex = this.mobileActiveIndex) {
      this.dots.forEach((dot, index) => {
        const fill = dot.querySelector('.performance-stats__mobile-dot-fill');
        if (!fill) return;

        fill.style.animation = 'none';
        fill.style.animationPlayState = '';
        fill.style.width = '0%';

        if (index === activeIndex) {
          if (this.mobileAutoplayEnabled) {
            requestAnimationFrame(() => {
              fill.style.animation = '';
            });
          } else {
            fill.style.width = '100%';
          }
        }
      });
    }

    startMobileAutoplay() {
      this.stopMobileAutoplay();

      if (
        !this.mobileAutoplayEnabled ||
        this.isDesktop() ||
        this.mobileSlides.length <= 1 ||
        this.prefersReducedMotion.matches ||
        document.hidden
      ) {
        return;
      }

      this.restartProgressAnimation();

      this.mobileAutoplayTimer = window.setTimeout(() => {
        if (this.mobileAutoplayPaused) {
          this.startMobileAutoplay();
          return;
        }

        const nextIndex = (this.mobileActiveIndex + 1) % this.mobileSlides.length;
        this.goToMobileSlide(nextIndex);
        this.startMobileAutoplay();
      }, this.mobileAutoplayDelay);
    }

    stopMobileAutoplay() {
      if (this.mobileAutoplayTimer) {
        clearTimeout(this.mobileAutoplayTimer);
        this.mobileAutoplayTimer = null;
      }
    }

    restartMobileAutoplay() {
      if (!this.isDesktop()) {
        this.startMobileAutoplay();
      }
    }

    onMobileInteraction() {
      this.mobileAutoplayPaused = true;
      this.stopMobileAutoplay();

      this.dots.forEach((dot) => {
        const fill = dot.querySelector('.performance-stats__mobile-dot-fill');
        if (fill) fill.style.animationPlayState = 'paused';
      });
    }

    onDotClick(event) {
      const index = Number(event.currentTarget.dataset.performanceDot);
      if (Number.isNaN(index)) return;

      this.mobileAutoplayPaused = false;
      this.goToMobileSlide(index);
      this.restartMobileAutoplay();
    }

    onVisibilityChange() {
      if (document.hidden) {
        this.stopMobileAutoplay();
        return;
      }

      this.mobileAutoplayPaused = false;
      this.restartMobileAutoplay();
    }

    goToMobileSlide(index) {
      const slide = this.mobileSlides[index];
      if (!slide || !this.mobileTrack) return;

      const targetLeft = slide.offsetLeft - (this.mobileTrack.clientWidth - slide.clientWidth) / 2;
      this.mobileTrack.scrollTo({ left: targetLeft, behavior: 'smooth' });

      this.mobileActiveIndex = index;
      this.updateMobilePagination(index);
    }

    goToSlide(index) {
      if (this.isDesktop()) {
        if (!this.scrollRoot || !this.cachedLayout) return;

        const { scrollDistance, maxIndex } = this.cachedLayout;
        const progress = maxIndex > 0 ? Math.max(0, Math.min(index, maxIndex)) / maxIndex : 0;
        const top = this.getScrollStart() + scrollDistance * progress;

        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        return;
      }

      this.mobileAutoplayPaused = false;
      this.goToMobileSlide(index);
      this.restartMobileAutoplay();
    }
  }

  if (!customElements.get('performance-stats')) {
    customElements.define('performance-stats', PerformanceStats);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-nav"] && !Shopify.designMode) return;
  try {
    
  class ProductStickyNav extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('[data-target]'));
      this.toggle = this.querySelector('[data-nav-toggle]');
      this.current = this.querySelector('[data-nav-current]');
      this.titleButton = this.querySelector('.product-sticky-nav__title');
      this.onScroll = this.onScroll.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onBackToTop = this.onBackToTop.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.sectionEl = this.closest('.shopify-section');
      this.headerSection = document.querySelector('.header-section');
      this.headerHeight = 0;

      this.links.forEach((link) => link.addEventListener('click', this.onClick));
      this.toggle?.addEventListener('click', this.onToggle);
      this.titleButton?.addEventListener('click', this.onBackToTop);
      document.addEventListener('click', this.onDocClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.cacheHeaderHeight();
      this.onScroll();
    }

    disconnectedCallback() {
      this.links.forEach((link) => link.removeEventListener('click', this.onClick));
      this.toggle?.removeEventListener('click', this.onToggle);
      this.titleButton?.removeEventListener('click', this.onBackToTop);
      document.removeEventListener('click', this.onDocClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.setHeaderPinned(false);
    }

    onResize() {
      this.cacheHeaderHeight();
      this.updateHeaderVisibility();
    }

    cacheHeaderHeight() {
      const cssHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      if (cssHeight > 0) {
        this.headerHeight = cssHeight;
        return;
      }

      const header = this.headerSection?.querySelector('header[is="sticky-header"], header[is="custom-header"]');
      this.headerHeight = header ? header.getBoundingClientRect().height : 0;
    }

    stickScrollTop() {
      if (!this.sectionEl) return Infinity;

      let top = 0;
      for (let element = this.sectionEl; element; element = element.offsetParent) {
        top += element.offsetTop;
      }
      return top - this.headerHeight;
    }

    updateHeaderVisibility() {
      if (!this.sectionEl || !this.headerSection) return;

      const pinned = window.scrollY >= this.stickScrollTop();
      this.setHeaderPinned(pinned);
    }

    setHeaderPinned(pinned) {
      this.headerSection.classList.toggle('header-hidden-by-product-nav', pinned);
      this.sectionEl.classList.toggle('is-flush-top', pinned);
      this.sectionEl.classList.toggle('is-stuck', pinned && this.sectionEl.getBoundingClientRect().top <= 1);

      if (pinned) {
        document.documentElement.style.setProperty('--sticky-header-height', '0px');
        return;
      }

      if (this.headerHeight > 0) {
        document.documentElement.style.setProperty('--sticky-header-height', `${this.headerHeight.toFixed(1)}px`);
      }
    }

    findTarget(id) {
      if (!id) return null;
      return (
        document.getElementById(id) ||
        document.getElementById(`shopify-section-${id}`) ||
        document.querySelector(`[data-anchor="${id}"]`)
      );
    }

    headerHidden() {
      return Boolean(
        this.headerSection?.classList.contains('header-hidden-by-product-nav') ||
          (this.headerSection?.classList.contains('header-hidden') &&
            this.headerSection.getAttribute('data-sticky-type') === 'on-scroll-up')
      );
    }

    offset() {
      const header = document.querySelector('.header-section header[is="sticky-header"]');
      const headerHeight = this.headerHidden() || !header ? 0 : header.getBoundingClientRect().height;
      return headerHeight + this.getBoundingClientRect().height;
    }

    onBackToTop() {
      this.close();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    onClick(event) {
      const id = event.currentTarget.getAttribute('data-target');
      const target = this.findTarget(id);
      if (!target) return;

      event.preventDefault();
      this.close();
      const top = window.scrollY + target.getBoundingClientRect().top - this.offset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      this.setActive(event.currentTarget);
    }

    onScroll() {
      if (!this.headerHidden()) this.cacheHeaderHeight();
      this.updateHeaderVisibility();
      const marker = window.scrollY + this.offset() + 8;
      let active = this.links[0];

      this.links.forEach((link) => {
        const target = this.findTarget(link.getAttribute('data-target'));
        if (target && window.scrollY + target.getBoundingClientRect().top <= marker) {
          active = link;
        }
      });

      if (active) this.setActive(active);
    }

    setActive(link) {
      this.links.forEach((item) => {
        const on = item === link;
        item.classList.toggle('is-active', on);
        item.classList.toggle('font-medium', on);
        item.classList.toggle('font-normal', !on);
      });
      if (this.current) this.current.textContent = link.textContent.trim();
    }

    onToggle(event) {
      event.stopPropagation();
      const open = !this.classList.contains('is-open');
      this.classList.toggle('is-open', open);
      this.toggle?.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    onDocClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    close() {
      this.classList.remove('is-open');
      this.toggle?.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('product-sticky-nav')) {
    customElements.define('product-sticky-nav', ProductStickyNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  class ScrollFeatureShowcase extends HTMLElement {
    connectedCallback() {
      this.scrollRoot = this.querySelector('[data-scroll-feature-scroll]');
      this.viewport = this.querySelector('.scroll-feature-showcase__viewport');
      this.stack = this.querySelector('[data-scroll-feature-stack]');
      this.slides = Array.from(this.querySelectorAll('[data-scroll-feature-slide]'));
      this.stickyNavSection = document.querySelector('.product-sticky-nav-section');

      this.navOffset = 0;
      this.cachedLayout = null;
      this.activeIndex = 0;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.updateViewportMetrics();

      requestAnimationFrame(() => {
        this.measureLayout();
        this.updateScroll(true);
      });

      this.stack?.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', this.onResize, { once: true });
      });

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      this.resizeObserver = new ResizeObserver(this.onResize);
      const navBar = document.querySelector('.product-sticky-nav__bar');
      if (navBar) this.resizeObserver.observe(navBar);
      if (this.stickyNavSection) this.resizeObserver.observe(this.stickyNavSection);
      this.resizeObserver.observe(this);

      this.onBlockSelect = (event) => {
        const index = Number(event.target.closest('[data-scroll-feature-slide]')?.dataset.scrollFeatureSlide);
        if (Number.isNaN(index)) return;
        this.goToSlide(index);
        this.setActiveSlide(index);
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.resizeObserver?.disconnect();
    }

    updateViewportMetrics() {
      const navBar = document.querySelector('.product-sticky-nav__bar');
      const navHeight = navBar ? navBar.offsetHeight : 0;
      this.navOffset = this.stickyNavSection ? this.stickyNavSection.offsetHeight : navHeight;

      this.style.setProperty('--scroll-feature-nav-offset', `${this.navOffset}px`);
      this.style.setProperty('--scroll-feature-viewport-height', `calc(100svh - ${navHeight}px)`);
    }

    measureLayout() {
      if (!this.scrollRoot || !this.viewport || this.slides.length === 0) {
        this.cachedLayout = null;
        return;
      }

      const stride = this.viewport.offsetHeight;
      const maxIndex = Math.max(0, this.slides.length - 1);
      const maxTravel = stride * maxIndex;

      this.style.setProperty('--scroll-feature-max-travel', `${maxTravel}px`);

      this.cachedLayout = {
        stride,
        maxTravel,
        maxIndex,
      };
    }

    getScrolled() {
      if (!this.scrollRoot) return 0;

      const rect = this.scrollRoot.getBoundingClientRect();
      return Math.max(0, this.navOffset - rect.top);
    }

    getScrollStart() {
      if (!this.scrollRoot) return 0;

      const rect = this.scrollRoot.getBoundingClientRect();
      return window.scrollY + rect.top - this.navOffset;
    }

    getActiveIndex(scrolled) {
      if (!this.cachedLayout) return 0;

      const { stride, maxIndex } = this.cachedLayout;
      if (stride <= 0) return 0;

      return Math.min(maxIndex, Math.max(0, Math.round(scrolled / stride)));
    }

    setActiveSlide(index) {
      if (index === this.activeIndex) return;

      this.activeIndex = index;

      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    updateScroll(force = false) {
      if (!this.cachedLayout) return;

      const activeIndex = this.getActiveIndex(this.getScrolled());

      if (force) {
        this.activeIndex = -1;
      }

      this.setActiveSlide(activeIndex);
    }

    onScroll() {
      if (!this.cachedLayout) return;

      const activeIndex = this.getActiveIndex(this.getScrolled());
      if (activeIndex === this.activeIndex) return;

      this.setActiveSlide(activeIndex);
    }

    onResize() {
      this.updateViewportMetrics();
      this.measureLayout();
      this.updateScroll(true);
    }

    goToSlide(index) {
      if (!this.scrollRoot || !this.cachedLayout) return;

      const { stride, maxIndex } = this.cachedLayout;
      const targetIndex = Math.min(maxIndex, Math.max(0, index));
      const top = this.getScrollStart() + stride * targetIndex;

      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }

  if (!customElements.get('scroll-feature-showcase')) {
    customElements.define('scroll-feature-showcase', ScrollFeatureShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
